import schemeOverviewEn from "./locales/en.json";

export const SCHEME_OVERVIEW_NS = "schemeOverview" as const;

export const SchemeOverviewPageTranslations = {
  en: {
    [SCHEME_OVERVIEW_NS]: {
      ...schemeOverviewEn,
    },
  },
};
